import { extendObservable, action } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';
import VimeoVideoUploadService from '../../../core/services/VimeoVideoUploadService';

export default class WebPageFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this);
    this.form.validations = {
      name: [isRequired],
      about: [isRequired],
    };
  }

  handleLoad = action(() => {
    this.form.reset();
    this.fetch
      .fetch({
        url: `/companies/${localStorage.company}/web-page-settings`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.form.setInitialValues(this.fetch.data);
        }
      });
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    const formData = new FormData();
    Object.keys(this.form.getValues())
      .filter((key) => key !== 'promotionVideoFile' && key !== 'comments')
      .forEach((key) => {
        formData.append(key, this.form.getValue(key));
      });

    this.submit
      .fetch({
        method: 'put',
        url: `/companies/${localStorage.company}/web-page-settings`,
        body: formData,
      })
      .then(() => {
        if (this.submit.data) {
          if (this.submit.data.promotionVideoUploadLink && this.form.getValue('promotionVideoFile')) {
            VimeoVideoUploadService.init();
            VimeoVideoUploadService.handleUpload(
              this.form.getValue('promotionVideoFile'),
              this.submit.data.promotionVideoUploadLink
            ).then(() => {
              NotificationService.addNotification('Web site page successfully updated', 'success');
              this.form.reset();
              this.form.setInitialValues(this.submit.data);
            });
          } else {
            NotificationService.addNotification('Web site page successfully updated', 'success');
            this.form.reset();
            this.form.setInitialValues(this.submit.data);
          }
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error to update web page', 'error');
        }
      });
  });
}
